export interface CollapsedSignalText {
	/** One line for the collapsed row (whitespace collapsed); CSS truncates it. */
	text: string | null;
	/** The same source, untruncated and with its own line breaks kept (trimmed only), for the hover title. */
	fullText: string | null;
}

export interface CollapsedSignalTextInput {
	title?: string | null;
	summary?: string | null;
}

const collapseWhitespace = (value: string): string => value.replace(/\s+/g, " ").trim();

/**
 * The text a collapsed signal row shows (PREC-5037 / PREC-5038): the summary when it has content,
 * otherwise the title. A summary can be multi-line (a LinkedIn post) or end in a trailing space (the
 * "Added employer" job-change variant), so the collapsed text collapses every whitespace run; the
 * full text keeps the source as written for the hover title. Truncation stays in CSS.
 */
export const collapsedSignalText = ({
	title,
	summary,
}: CollapsedSignalTextInput): CollapsedSignalText => {
	const summaryFull = (summary ?? "").trim();

	if (summaryFull) {
		return { text: collapseWhitespace(summaryFull), fullText: summaryFull };
	}

	const titleFull = (title ?? "").trim();

	if (titleFull) {
		return { text: collapseWhitespace(titleFull), fullText: titleFull };
	}

	return { text: null, fullText: null };
};
